import { graphql } from '@generated/gql';

export const FETCH_CUSTODIAN_CONNECTION_NAMES = graphql(/** GraphQL */ `
  query custodianConnectionBreadcrumbFetchCustodianConnectionNames(
    $input: FetchCustodianConnectionsInput!
  ) {
    fetchCustodianConnections(input: $input) {
      custodianConnections {
        id
        name
      }
    }
  }
`);
